<nz-page-header
  class="site-page-header"
  nzBackIcon
  [nzTitle]="idForUpdate ? 'Update Question' : 'Add Question'" *ngIf="!isFromOtherComponent"
>
</nz-page-header>
<app-bulk-question [questionType]="'NORMAL'" [isFromOtherComponent]= "isFromOtherComponent" [idForUpdate]="idForUpdate" ></app-bulk-question>
